// extracted by mini-css-extract-plugin
export default {"actions":"dltvXkvsi_IQfp3euAb5"};